import { initTimeline } from './utils/timeline';

document.addEventListener('DOMContentLoaded', function () {
  const timeline = document.querySelector('.timeline');
  const expandBtn = document.querySelector('.timeline__expand-btn');

  const { observeAnimateItems, updateSpineColors } = initTimeline({
    timelineSelector: '.timeline',
    prefix: 'timeline',
  });

  if (timeline && observeAnimateItems) {
    // Observe first 4 items on load with immediate animation
    const animateItems = document.querySelectorAll(
      '.timeline__item[data-animate]:not(.timeline__item--hidden), .timeline__mobile-item[data-animate]',
    );
    observeAnimateItems(animateItems, true);
  }

  if (expandBtn && observeAnimateItems && updateSpineColors) {
    expandBtn.addEventListener('click', function () {
      const hiddenItems = document.querySelectorAll('.timeline__item--hidden');

      hiddenItems.forEach((item) => {
        item.classList.remove('timeline__item--hidden');
        item.classList.add('timeline__item--visible');
      });
      this.setAttribute('aria-expanded', 'true');
      timeline?.classList.add('timeline--expanded');

      // Observe newly visible items for scroll animation
      setTimeout(() => {
        const newAnimateItems = document.querySelectorAll(
          '.timeline__item[data-animate]:not(.is-animated)',
        );
        observeAnimateItems(newAnimateItems);
      }, 100);

      // Update spine colors as expansion happens
      updateSpineColors();
      setTimeout(updateSpineColors, 100);
      setTimeout(updateSpineColors, 300);
      setTimeout(updateSpineColors, 500);
    });
  }
});
